module.exports = __webpack_public_path__ + "media/packs/images/flags/CN-d96d8f43655ce18bbd3fcffdbb8c5ca1.png";